import React from 'react'
import RaisedButton from 'material-ui/RaisedButton'

class FileInput extends React.Component<any, any> {
  render () {
    return (
      <RaisedButton
        containerElement='label'
        label={this.props.label}
      >
        <input
          accept={this.props.accept}
          type='file'
          style={{ display: 'none' }}
          onChange={this.handleFileChange.bind(this)}
// @ts-ignore
          onClick={(e) => { e.target.value = '' }}
        />
      </RaisedButton>
    )
  }

  handleFileChange (e) {
    const file = e.target.files[0]
    this.props.onFileSelected(file)
  }
}

// @ts-ignore
FileInput.propTypes = {
  accept: React.PropTypes.string,
  onFileSelected: React.PropTypes.func.isRequired,
  label: React.PropTypes.string.isRequired
}

// @ts-ignore
FileInput.defaultProps = {
  label: 'Upload File'
}

export default FileInput
